var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-text"},[_c('div',{staticClass:"scroll-text-content",style:({transform: `translateX(${_vm.width - _vm.left}px)`})},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }